var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app",style:(_vm.cssVars)},[_c('Header',{on:{"changeMenuViewState":_vm.changeMenuStateView}}),_c('div',{staticClass:"main-container"},[_c('dropdown-menu',{attrs:{"elements":_vm.elements,"isActive":_vm.isMenuActive}}),_c('main',{staticClass:"main-content"},[_c('router-view',{key:_vm.$route.fullPath})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }